var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.classPrefix),
    !_vm.parentComponent && (_vm.classPrefix + "--border")
]},[(_vm.parentComponent && _vm.parentComponent.showFilterablePanel)?_c('cascader-item',{attrs:{"data":_vm.parentComponent.currentFilterableData,"show-path-label":""}}):_c('cascader-item',{attrs:{"data":_vm.parentComponent ? _vm.data : _vm.currentData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }